import { connect } from 'react-redux';
import ForgotPassword from '../../components/login/ForgotPassword';
import { resendUsernameOrPassword } from '../../actions/user.actions';

const mapDispatchToProps = dispatch => ({
    resendUsernameOrPassword: (email, action) => dispatch(resendUsernameOrPassword({email, action})),
});

export default connect(null, mapDispatchToProps)(ForgotPassword);
